import CRUDReducer from './reducer';
import CRUDActioner from './actioner';
import CRUDApi from './api';
import CRUDSelectors from './selectors';
import CRUDService from './service';
export { CRUDReducer, CRUDActioner, CRUDApi, CRUDSelectors, CRUDService };
